export const customerSettingsRoutes = [
  {
    path: "settings",
    name: "custSettings",
    component: () => import("@/modules/Settings/views/Customer"),
    redirect: {
      name: "customer-settings-administrators",
    },
    children: [
      {
        path: "administrators",
        name: "customer-settings-administrators",
        component: () =>
          import("@/modules/Settings/views/Customer/Administrators/index.vue"),
      },
      {
        path: "connections",
        name: "customer-settings-connections",
        component: () =>
          import("@/modules/Settings/views/Customer/Connections/index.vue"),
      },
      {
        path: "connections-v2",
        name: "customer-settings-connections-v2",
        component: () =>
          import("@/modules/Settings/views/Customer/ConnectionsV2/index.vue"),
      },
      {
        path: "saml-sso",
        name: "customer-settings-saml-sso",
        component: () =>
          import("@/modules/Settings/views/Customer/Saml/index.vue"),
      },
    ],
  },
];

export const customerRoutes = {
  path: "",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: customerSettingsRoutes,
};
